// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C4ox","label":"styles_label__9_r54"};